/**
 * Draft app-store screenshot pages are temporary.
 * Valid through this date inclusive (local calendar day); expired from the next day 00:00.
 */
export const SCREENSHOT_ACCESS_VALID_THROUGH = "2027-01-01";

function screenshotAccessExpiresAtMs() {
    const [y, m, d] = SCREENSHOT_ACCESS_VALID_THROUGH.split("-").map(Number);
    return new Date(y, m - 1, d + 1, 0, 0, 0, 0).getTime();
}

export function formatScreenshotAccessValidThroughLabel() {
    return SCREENSHOT_ACCESS_VALID_THROUGH;
}

export function formatScreenshotAccessExpiredLabel() {
    const [y, m, d] = SCREENSHOT_ACCESS_VALID_THROUGH.split("-").map(Number);
    return new Date(y, m - 1, d + 1, 0, 0, 0, 0).toLocaleString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
}

/** Slugs covered by the expiry gate (screenshot + animation scenes 01–10). */
export const SCREENSHOT_EXPIRED_SLUGS = new Set(
    ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"].map(String),
);

export function isScreenshotSlugGated(slug) {
    return SCREENSHOT_EXPIRED_SLUGS.has(String(slug ?? "").trim());
}

export function isScreenshotAccessExpired(now = new Date()) {
    return now.getTime() >= screenshotAccessExpiresAtMs();
}

export function isScreenshotSceneExpired(slug, now = new Date()) {
    return isScreenshotSlugGated(slug) && isScreenshotAccessExpired(now);
}
